import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Login component for user authentication
 * @param {Object} props - Component props
 * @param {Function} props.onSuccess - Function to call on successful login
 * @returns {JSX.Element} Login component
 */
const Login = ({ onSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { signIn, authError, domainRestriction } = useAuth();

  /**
   * Handle form submission
   * @param {Event} e - Form submit event
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      const { user, error } = await signIn({ email, password });
      
      if (error) {
        setError(error.message);
      } else if (user) {
        if (onSuccess) onSuccess();
      }
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form">
      <h2>Log In</h2>
      {domainRestriction && (
        <p className="domain-restriction">Only @{domainRestriction} email addresses are allowed</p>
      )}
      
      {error && <div className="error">{error}</div>}
      {authError && <div className="error">{authError}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={domainRestriction ? `yourname@${domainRestriction}` : "Email address"}
            required
            disabled={loading}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
          />
        </div>
        
        <button type="submit" disabled={loading}>
          {loading ? 'Logging In...' : 'Log In'}
        </button>
      </form>
      
      <div className="auth-links">
        <p>
          <a href="#" onClick={() => onSuccess('reset-password')}>Forgot Password?</a>
        </p>
        <p>
          Don't have an account? <a href="#" onClick={() => onSuccess('signup')}>Sign Up</a>
        </p>
      </div>
    </div>
  );
};

export default Login; 